module.exports = __webpack_public_path__ + "img/masterImage_1@2x.08fab18d.png";